<template>
    <div class="header">
        <div class="header-left">
            <h3 class="title">
                <router-link to="/welcome" class="index-link">前端配置中心</router-link>
            </h3>
        </div>
        <div class="header-right">
            <el-dropdown class="user-info" @command="handleCommand">
                <span class="el-dropdown-link">
                    <img
                        v-if="userInfo.avatar !== ''"
                        class="avatar"
                        :src="userInfo.avatar"
                    />
                    <img
                        v-else
                        class="avatar"
                        src="../../assets/img/default_avatar.jpg"
                    />
                    <div class="name">
                        {{ userInfo.realname
                        }}<i class="el-icon-caret-bottom el-icon--right"></i>
                    </div>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="logout">
                        <i class="el-icon el-icon-my-zhuxiao"></i> 注销
                    </el-dropdown-item>
                    <el-dropdown-item command="userlogout">
                        <i class="el-icon el-icon-my-quanxian"></i> 跳转到登录页
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import apiPath from "../../service/apiPath.js";

export default {
    data() {
        return {
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        mockRoles() {
            return this.$store.state.mockRoles;
        }
    },
    methods: {
        handleCommand(command) {
            switch (command) {
                case "logout":
                    if (this.userInfo.type === 1) {
                        window.location.href = `${apiPath.AUTH_LOGOUT()}`;
                    } else if (this.userInfo.type === 2) {
                        this.$store
                            .dispatch("logout", this.loginForm)
                            .then(() => {
                                window.location.href = `${window.location.origin}${window.location.pathname}`;
                            });
                    } else if (!this.userInfo.user_id) {
                        this.$router.replace("/login");
                    }
                    break;
                case "userlogout":
                    this.$store.dispatch("logout", this.loginForm).then(() => {
                        window.location.href = `${window.location.origin}${window.location.pathname}`;
                    });
                    break;
                default:
                    break;
            }
        },
        changeRole(id) {
            this.$router.replace("/welcome");
            this.$store.commit("UPDATE_USER_INFO", id);
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped>
@import url("../../styles/variable.less");
.header {
    box-sizing: border-box;
    // background: @mainColor;
    background: #1a253f;
    color: #fff;
    // text-align: justify;
    border: 0 none;
    font-size: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;
    height: 50px;
    overflow: hidden;
}
.header-left {
    line-height: 50px;
    text-align: left;
    float: left;
    .title {
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        width: 200px;
        text-align: center;
        color: #fff;
    }
    .index-link {
        color: #fff !important;
        text-decoration: none;
    }
}
.header-right {
    line-height: 50px;
    float: right;
    .btn {
        margin-left: 5px;
        background: #fff;
        padding: 5px 10px;
    }
}
.logo-link {
    display: block;
    height: 40px;
    position: absolute;
    left: 200px;
    top: 5px;
    .logo {
        height: 100%;
        vertical-align: top;
    }
}
.help-btn {
    display: inline-block;
    vertical-align: top;
    margin: 8px 10px 0 0;
}
.user-info {
    display: inline-block;
    margin: 5px 10px 0 0;
    .avatar {
        width: 35px;
        height: 35px;
        border-radius: 20px;
        margin-top: 2px;
        display: inline-block;
        vertical-align: top;
    }
    .name {
        display: inline-block;
        vertical-align: top;
    }
    .el-dropdown-link {
        display: block;
        cursor: pointer;

        background-color: #fff;
        border-radius: 10px;
        padding: 0 5px;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        &:hover {
            background-color: #e5e5e5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/containWraper/head.vue